/* BD HERBS — <bd-accordion>: smooth open/close for the <details> inside it.
   Without JS the native <details> still opens and closes. */
if (!customElements.get('bd-accordion')) {
  customElements.define(
    'bd-accordion',
    class BdAccordion extends HTMLElement {
      connectedCallback() {
        if (this.bound) return; // reconnects (theme editor moving sections) must not add a second listener
        this.bound = true;
        this.addEventListener('click', (event) => {
          const summary = event.target.closest('summary');
          if (!summary || !this.contains(summary)) return;
          const details = summary.parentElement;
          const panel = details.querySelector('[data-panel]');
          if (!panel || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          event.preventDefault();
          this.toggle(details, panel);
        });
      }

      toggle(details, panel) {
        // A tap while closing re-opens it
        const opening = !details.open || details.classList.contains('is-closing');
        if (panel.animation) panel.animation.cancel();
        if (opening) details.open = true;
        details.classList.toggle('is-closing', !opening);
        const full = `${panel.scrollHeight}px`;
        panel.style.overflow = 'hidden';
        panel.animation = panel.animate(
          { height: opening ? ['0px', full] : [full, '0px'], opacity: opening ? [0, 1] : [1, 0] },
          { duration: 280, easing: 'cubic-bezier(0.2, 0, 0, 1)' }
        );
        panel.animation.onfinish = () => {
          panel.animation = null;
          panel.style.overflow = '';
          if (!opening) details.open = false;
          details.classList.remove('is-closing');
        };
        panel.animation.oncancel = () => {
          panel.animation = null;
          details.classList.remove('is-closing');
          panel.style.overflow = '';
        };
      }
    }
  );
}
